import { useState } from 'react';
import { useIntl } from 'react-intl';
import Input from '../../../forms/Input';

const Discovery = () => {
  const [fields, setFields] = useState({});
  const intl = useIntl();

  const handleFieldChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    // create a copy of actual values
    const newFields = Object.assign({}, fields);

    // update with new value
    newFields[name] = value;

    // update state
    setFields(newFields);
  };

  return (
    <div className="flex flex-col mt-10 mb-10">
      <h2 className="font-bold text-2xl mt-3 mb-5">
        {intl.formatMessage({ id: 'Search in library' })}
      </h2>
      <div className="grid grid-cols-3 gap-2">
        <Input
          className="col-1/3 flex flex-col justify-between items-start px-6 py-2 text-left bg-white border border-primary border-opacity-40 rounded-xl"
          name="search_in_discovery"
          type="text"
          value={fields['search_in_discovery'] || ''}
          onChange={handleFieldChange}
        />
        <a
          className="inline-flex items-center justify-center px-6 py-2 border border-transparent shadow-sm font-bold rounded-3xl text-sm text-white text-center bg-primary hover:bg-secondary focus:outline-none disabled:bg-lightGrey"
          href={
            'https://citeinternationale.on.worldcat.org/v2/search?queryString=' +
            fields['search_in_discovery'] +
            '&clusterResults=true&stickyFacetsChecked=true&groupVariantRecords=false'
          }
          rel="noreferrer"
          target="_blank"
        >
          {intl.formatMessage({ id: 'Search' })}
        </a>
      </div>
    </div>
  );
};

export default Discovery;
